module.exports = __webpack_public_path__ + "static/img/rectangle-gray.3550b14.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/rectangle-gray.png
// module id = EleV
// module chunks = 1